import React, { useEffect, useState } from 'react';
import ErrorMessage from '../../components/ErrorMessage';
import { Container, ContainerFluid } from '../../components/Layout';
import LoadingState from '../../components/LoadingState';
import SectionHeader from '../../components/SectionHeader';
import { NewPurchasesOverlay, deleteRecentlyPaired, getRecentlyPaired } from '../pairing';
import { getCurriculumAccess, type CurriculumAccess } from './api/getCurriculumAccess';
import BibleStudiesInformationBanner from './components/BibleStudiesInformationBanner';
import BibleStudyCards from './components/BibleStudyCards';
import { sortCurriculumBrands } from './utils/sortCurriculum';

export default function BibleStudies() {
  const [data, setData] = useState<{
    curriculumAccess?: CurriculumAccess;
    recentlyPaired?: ReturnType<typeof getRecentlyPaired>;
    isLoading: boolean;
    isError?: boolean;
  }>({ isLoading: true });
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    getCurriculumAccess()
      .then(curriculumAccess => {
        return setData({
          curriculumAccess: sortCurriculumBrands(curriculumAccess),
          recentlyPaired: getRecentlyPaired(),
          isLoading: false,
        });
      })
      .catch(() => setData(prev => ({ ...prev, isError: true, isLoading: false })));

    return () => {
      deleteRecentlyPaired();
    };
  }, []);

  return (
    <ContainerFluid style={{ margin: '30px auto 0 auto' }}>
      <Container data-qa-hook="bibleStudiesView">
        <SectionHeader title="Ongoing Curriculum" />
      </Container>
      {data.isLoading ? (
        <Container>
          <LoadingState />
        </Container>
      ) : data.isError || !data.curriculumAccess ? (
        <Container>
          <ErrorMessage />
        </Container>
      ) : (
        <>
          <Container>
            <BibleStudyCards curriculumAccess={data.curriculumAccess} recentlyPaired={data.recentlyPaired} />
          </Container>
          <BibleStudiesInformationBanner onShowOverlay={() => setShowOverlay(true)} />
          <NewPurchasesOverlay
            domain="curriculum"
            items={showOverlay ? undefined : data.recentlyPaired}
            showOverlay={showOverlay}
            onClosed={() => setShowOverlay(false)}
          />
        </>
      )}
    </ContainerFluid>
  );
}
